import FirebaseContext, { WithFirebase } from './context';
import Firebase from './firebase';

export default Firebase;

export { FirebaseContext, WithFirebase };